import avatarPic from './assets/images/avatar2.png'
export let NavConfig = {
     logo : ['The', 'Products'],
     pages : ['Home', 'About', 'Products', 'Testimonial','Shop'],
}
export const testimonialsList = [
       {
         name: "Mr Partil",
         avtar: avatarPic,
         rating: "⭐⭐⭐⭐⭐",
         review:
           "Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging across all continents except Antarctica",
       },
       {
         name: "Mr Partil",
         avtar: avatarPic,
         rating: "⭐⭐⭐⭐⭐",
         review:
           "Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging across all continents except Antarctica",
       },
       {
         name: "Mr Partil",
         avtar: avatarPic,
         rating: "⭐⭐⭐⭐⭐",
         review:
           "Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging across all continents except Antarctica",
       },
       {
         name: "Mr Partil",
         avtar: avatarPic,
         rating: "⭐⭐⭐⭐⭐",
         review:
           "Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging across all continents except Antarctica",
       },
       {
         name: "Mr Partil",
         avtar: avatarPic,
         rating: "⭐⭐⭐⭐⭐",
         review:
           "Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging across all continents except Antarctica",
       },
       {
         name: "Mr Partil",
         avatar: avatarPic,
         rating: "⭐⭐⭐⭐⭐",
         review:
           "Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging across all continents except Antarctica",
       },
     ];
     
